import Layout from '@/layouts/affiliate/affiliateLayout'

const affiliateRoute = [{
  path: '/affiliate',
  component: Layout,
  redirect: { name: 'AffiliateDashboard' },
  children: [{
    path: 'dashboard',
    name: 'AffiliateDashboard',
    component: () => import('@/views/affiliate/dashboard')
  }, {
    path: 'report',
    name: 'Report',
    component: () => import('@/views/affiliate/report')
  }, {
    path: 'report/signLaborStatement',
    name: 'ReportSignLaborStatement',
    component: () => import('@/views/affiliate/report/sign-labor-statement')
  }, {
    path: 'tools',
    name: 'AffiliateTools',
    component: () => import('@/views/affiliate/tools')
  }, {
    path: 'exclusive-link',
    name: 'AffiliateExclusiveLink',
    component: () => import('@/views/affiliate/tools/exclusive-link')
  }, {
    path: 'recent-activities',
    name: 'AffiliateRecentActivities',
    component: () => import('@/views/affiliate/tools/recent-activities')
  }, {
    path: 'product-media',
    name: 'AffiliateProductMedia',
    component: () => import('@/views/affiliate/tools/product-media')
  }, {
    path: 'my-kkpartners',
    name: 'MyKkpartners',
    component: () => import('@/views/affiliate/my-kkpartners')
  }, {
    path: 'help',
    name: 'Help',
    component: () => import('@/views/affiliate/help')
  }, {
    path: 'data/contract/:cid',
    name: 'AffiliateCooperationAgreement',
    component: () => import('@/views/affiliate/my-kkpartners/cooperation-agreement')
  }, {
    path: 'data/contract/:cid/appendixNew',
    name: 'affiliateKkdayContractAppendixNew',
    component: () => import('@/views/affiliate/my-kkpartners/agreement-appendix')
  }, {
    path: 'data/contract/:cid/additionalList',
    name: 'affiliateKkdayContractAdditionalList',
    component: () => import('@/views/affiliate/my-kkpartners/additional-list')
  },{
    path: 'notification',
    name: 'AffiliateNotification',
    component: () => import('@/views/affiliate/notification')
  }, {
    path: 'member-reward',
    name: 'AffiliateMember',
    component: () => import('@/views/affiliate/member-reward')
  }, {
    path: 'member-reward/prod-sponsor/:step',
    name: 'AffiliateMemberProdSponsor',
    component: () => import('@/views/affiliate/member-reward/prod-sponsor'),
    beforeEnter: (to, from, next) => {
      if(['1', '2', '3'].includes(to.params.step)) {
        next()
      } else {
        next('/404')
      }
    }
  }, {
    path: 'member-reward/fans-discount/:step',
    name: 'AffiliateMemberFansDiscount',
    component: () => import('@/views/affiliate/member-reward/fans-discount'),
    beforeEnter: (to, from, next) => {
      if(['1', '2'].includes(to.params.step)) {
        next()
      } else {
        next('/404')
      }
    }
  }, {
    path: 'member-reward/prod-sponsor-preview',
    name: 'AffiliateMemberProdSponsorPreview',
    component: () => import('@/views/affiliate/member-reward/prod-sponsor-preview')
  }, {
    path: 'member-reward/prod-sponsor-success',
    name: 'AffiliateMemberProdSponsorSuccess',
    component: () => import('@/views/affiliate/member-reward/prod-sponsor-success')
  }, {
    path: 'member-reward/fans-discount-preview',
    name: 'AffiliateMemberFansDiscountPreview',
    component: () => import('@/views/affiliate/member-reward/fans-discount-preview')
  }, {
    path: 'member-reward/fans-discount-success',
    name: 'AffiliateMemberFansDiscountSuccess',
    component: () => import('@/views/affiliate/member-reward/fans-discount-success')
  }]
}]
export default affiliateRoute
